import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import XbtnTitleHeader from '../../common/header/XbtnTitleHeader';
import { MESSAGE, PROP, TYPE, URL } from '../../../constant';
import { useAlert, useLearningHistory, useStarShop, useUserInfo } from '../../../hooks';
import { getUserAgent } from '../../../utils/utilityEtc';
import { learnerChoiceAPI } from '../../../api/accountAPI';
import { membersLearnersAPI } from '../../../api/entryExternal';
import { diagnosisProposalSelAPI } from '../../../api/diagnosisAPI';
import { setActor, mathpidLogAPICall } from '../../../redux/logData';

function LearnerChoice(props) {
  const location = useLocation();
  const logDispatch = useDispatch();
  const history = useHistory();
  const [Alert] = useAlert();

  const { setInfo } = useUserInfo();
  const { starAuthAPICall } = useStarShop();
  const { setLearningHistoryInfo } = useLearningHistory();
  
  const [learners, setLearners] = useState();
  const [cstmrNo, setCstmrNo] = useState();
  const ICON = [
    "static/images/icon/ic_account_01.svg",
    "static/images/icon/ic_account_02.svg",
    "static/images/icon/ic_account_03.svg",
    "static/images/icon/ic_account_04.svg",
    "static/images/icon/ic_account_05.svg",
  ]

  useEffect(() => {
    const { state } = location;

    if (state?.learner) {
      const { learner } = state;
      setLearners(learner);
    } else {
      Alert(
        MESSAGE.INVALID_ACCESS,
        () => history.push(URL.ACCOUNT.LOGIN),
        "msg005"
      )
    }
  }, []);

  const handleClick = useCallback(async (item, index) => {
    const { state } = location;
    if (!state?.sbsceMbrId) return;
    const { sbsceMbrId, learner } = state;
    starAuthAPICall(item.cntrtNo);
    setCstmrNo(item.cstmrNo);

    const resp = await learnerChoiceAPI({
      sbsceMbrId,
      cstmrNo: item.cstmrNo,
      contract: item.cntrtNo
    });

    if (!resp) return;

    if (resp?.code === 'E000017') {
      const isLoginChk = localStorage.getItem('mathpidLoginChk');
      if (isLoginChk === 'Y') {
        window.location = `${URL.ACCOUNT.LOGIN}?LAUNCH_TYPE=GM_APP&CHN_CD=BRS1000`
      } else {
        history.push(URL.ACCOUNT.LOGIN);
      }

      return;
    }

    // 특정학습회원 조회
    const memberResp = await membersLearnersAPI(state.sbsceMbrId, resp.lrnMbrId);
    const { brthmt, sxdnCd, mbrNm, mbrId, tutoYn, emailAdrs } = memberResp;
  
    const diagnosisResp = await diagnosisProposalSelAPI(mbrId);
    const { dgnsRsltCnfmYn, dgnsYn, memberYn } = diagnosisResp;

    logDispatch(setActor({
      account: {
        homePage: TYPE.ENTRY_TYPE.GM_APP,
        name: mbrId
      },
      name: item.cstmrNo,
    }))

    setTimeout(() => {
      // 앱 최초 진입시 호출
      logDispatch(mathpidLogAPICall({
        verbId: 'focused',
        objectId: 'application',
        idName: getUserAgent('packageName'),
        idValue: getUserAgent('VERSION_NAME')
      }));
    }, 0);

    localStorage.setItem('iIidx', index);
    localStorage.setItem('learner.id', resp.lrnMbrId);
    
    setLearningHistoryInfo({
      isTutorial: tutoYn,
      isCompleteAIDiagnosis: dgnsYn,
      isCheckAIDiagnosisResult: dgnsRsltCnfmYn,
    });
    
    setInfo({
      cntrtNo: item.cntrtNo,
      learnerCode: item.cstmrNo,
      userId: state.sbsceMbrId,
      userEmail: emailAdrs ? emailAdrs : localStorage.getItem("access.email"),
      locale: 'KO',
      learnerId: resp.lrnMbrId,
      learnerBirth: brthmt,
      learnerSex: sxdnCd,
      learnerName: mbrNm,
      isMember: memberYn,
      iconImage: PROP.SIDE_ICON[index] ? PROP.SIDE_ICON[index] : PROP.SIDE_ICON[0],
      learner
    });

    history.push(URL.SELECT_LEARNING);
  }, [location]);

  return (
    <div className="layout-def layout-lc bg_gray">
      <XbtnTitleHeader
        title="학습자 선택"
      />
      <div className="container">
        <div className="inner">
          <div className="centermiddleBox">
            <div className="centermiddleBox-item learnerChoice-wrap">
              <div className="learnerChoice-tit">
								<h2>학습자를 선택해주세요.</h2>
              </div>
              <div className="learnerChoice-list">
                <ul>
                  {
                    (learners && learners.length > 0) && (
                      learners.map((item, index) => (
                        <li key={item.cstmrNo}>
                          <button
                            className={clsx({ active: item.cstmrNo === cstmrNo})}
                            onClick={() => handleClick(item, index)}
                          >
                            <div className="profile-imgBox">
                              <img src={ICON[index] ? ICON[index] : ICON[0] } alt="" />
                            </div>
                            <div className="profile-txtBox">
                              <p dangerouslySetInnerHTML={{ __html: item.name }} />
                            </div>
                          </button>
                        </li>
                      )
                    ))
                  }
                </ul>
              </div>
              <div className="learnerChoice-txt">
								{/* <p>학습자 추가, 삭제, 수정은 <a href="#">MY</a>에서 가능합니다.</p> */}
							</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LearnerChoice;